import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import React, { PropsWithChildren } from "react";
import { AppDimmer } from "../AppDimmer";

type NativeHTMLDivElement = Omit<JSX.IntrinsicElements["div"], "title" | "ref">;

export interface AppAbstractModalProps extends NativeHTMLDivElement {
  isOpen: boolean;
  className?: string;
  withAnimatePresence?: boolean;
  onRequestClose?: () => void;
}

export const AppAbstractModal = React.forwardRef(
  (props: PropsWithChildren<AppAbstractModalProps>, ref: React.Ref<HTMLDivElement>) => {
    const { isOpen, onRequestClose, withAnimatePresence: $withAnimatePresence, ...rest } = props;
    const withAnimatePresence = props.withAnimatePresence ?? true;

    const modal = (
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{ position: "fixed", zIndex: 2 }}
      >
        <div {...rest} className={classNames("AppAbstractModal", props.className)}>
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
            transition={{ ease: [0.2, 1.15, 0.35, 1.15], duration: 0.5 }}
            className="container"
          >
            {props.children}
          </motion.div>
          <AppDimmer onClick={props.onRequestClose} />
        </div>
      </motion.div>
    );

    return withAnimatePresence ? <AnimatePresence>{isOpen && modal}</AnimatePresence> : modal;
  }
);
